import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import ui from "features/ui/uiSlice";
import download from "features/download/downloadSlice";
import software from "features/software/softwareSlice";
import signup from "features/signup/signupSlice";
import verifyUser from "features/verifyUser/verifyUserSlice";
import login from "features/login/loginSlice";
import auth from "features/auth/authSlice";
import activation from "features/activation/activationSlice";
import reset from "features/reset/resetSlice";
import profile from "features/profile/profileSlice";
import trial from "features/trial/trialSlice";
import optin from "features/optin/optinSlice";

export const store = configureStore({
  reducer: {
    download,
    software,
    activation,
    signup,
    ui,
    verifyUser,
    login,
    auth,
    reset,
    profile,
    trial,
    optin,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = typeof store.dispatch;
